import { useGetBalanceQuery } from '../components/services/services';
import { usePermission } from './usePermission';

const BALANCE_PERMISSION_CODE = 'Corporate.GET.Reading.FirmaBakiyeErişimi';

export const useCompanyBalance = (companyId?: number) => {
  const { hasPermission: canReadCompanyBalance, isLoading: isBalancePermissionLoading } = usePermission({
    code: BALANCE_PERMISSION_CODE,
  });

  const query = useGetBalanceQuery(companyId as number, {
    skip: !companyId || !canReadCompanyBalance || isBalancePermissionLoading,
  });

  return {
    ...query,
    canReadCompanyBalance,
    isBalancePermissionLoading,
  };
};
